import React, { Component } from 'react'

const Hamburger = (props) => {
  const activeClass = props.sidebarExpanded ? 'toolbar__hamburger-active' : ''

  return (
    <div className={`toolbar__hamburger ${activeClass}`} onClick={props.onSidebarExpand}>
      <span></span>
    </div>
  )
}

export default Hamburger



// WEBPACK FOOTER //
// ./app/javascript/components/application/layout/toolbar/hamburger.js